/* eslint-disable */
export default {
  pages: {
    key: "title",
    data: [
      {title: 'Moje produkty',   url: '/',      icon: 'HomeIcon', is_bookmarked: false},
      {title: 'Baza składników', url: '/baza-skladnikow', icon: 'FileIcon', is_bookmarked: false},
      {title: 'Moje konto', url: '/moje-konto', icon: 'FileIcon', is_bookmarked: false},
      {title: 'Subskrypcji', url: '/subscriptions', icon: 'FileIcon', is_bookmarked: false},
      {title: 'Kontakt', url: '/kontakt', icon: 'FileIcon', is_bookmarked: false},
      {title: 'Wyloguj', url: '/wyloguj', icon: 'FileIcon', is_bookmarked: false},
    ]
  }
}
/* eslint-enable */
